import { render, staticRenderFns } from "./ChartjsBarChart.vue?vue&type=template&id=4b03246d&"
import script from "./ChartjsBarChart.vue?vue&type=script&lang=js&"
export * from "./ChartjsBarChart.vue?vue&type=script&lang=js&"
import style0 from "./ChartjsBarChart.vue?vue&type=style&index=0&id=4b03246d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports